export default {"src":"/_next/static/media/rush-hour.c2a1ed25.svg","height":2200,"width":2268};